import { useSelector } from "react-redux";

// Soft UI Dashboard React components
import SuiTypography from "components/SuiTypography";

// Soft UI Dashboard React context
import { useSoftUIController } from "context";

// The name of the organization the admin is in (or, for a platform admin, the
// one they are viewing), set like the sidebar's section titles. Platform admins
// switch organizations from the Organizations page.
function OrganizationSection() {
  const organization = useSelector((state) => state.auth.organization);
  const [controller] = useSoftUIController();

  if (!organization || controller.miniSidenav) return null;

  return (
    <SuiTypography
      display="block"
      variant="caption"
      fontWeight="bold"
      textTransform="uppercase"
      opacity={0.6}
      pl={3}
      mt={1.5}
      mb={1.25}
      ml={1}
    >
      {organization.name}
    </SuiTypography>
  );
}

export default OrganizationSection;
